var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75053 12.7901C9.45617 10.3123 13.2545 8.66577 15.1618 7.86698C20.5903 5.60103 21.7314 5.20978 22.465 5.19348C22.628 5.19348 22.9867 5.22609 23.2312 5.42171C23.4268 5.58473 23.4757 5.79665 23.5083 5.95967C23.541 6.12269 23.5736 6.46502 23.541 6.72585C23.2475 9.8232 21.976 17.3383 21.3239 20.7943C21.0468 22.2615 20.5088 22.7506 19.9872 22.7995C18.846 22.8973 17.982 22.0496 16.8898 21.3323C15.1618 20.2075 14.2 19.5065 12.5209 18.398C10.581 17.1264 11.8362 16.4254 12.9448 15.2843C13.2382 14.9909 18.2429 10.4264 18.3407 10.0188C18.357 9.96992 18.357 9.7743 18.2429 9.67648C18.1287 9.57867 17.9657 9.61128 17.8353 9.64388C17.656 9.67648 14.9173 11.5023 9.58659 15.105C8.8041 15.643 8.10312 15.9038 7.46735 15.8875C6.76637 15.8712 5.42962 15.4962 4.41891 15.1702C3.19627 14.779 2.21816 14.567 2.29967 13.8824C2.34858 13.5237 2.83763 13.1651 3.75053 12.7901Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIconTelegram);
export default __webpack_public_path__ + "static/media/brand-icon_telegram.cff89bb6bb9602b5c7c2610cab2508e2.svg";
export { ForwardRef as ReactComponent };